import { render, staticRenderFns } from "./FullScreenFileDrop.vue?vue&type=template&id=539c0716&"
import script from "./FullScreenFileDrop.vue?vue&type=script&lang=js&"
export * from "./FullScreenFileDrop.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenFileDrop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports